import { render, staticRenderFns } from "./change-pay-way-dialog.vue?vue&type=template&id=0b12f2ee&scoped=true&"
import script from "./change-pay-way-dialog.vue?vue&type=script&lang=js&"
export * from "./change-pay-way-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b12f2ee",
  null
  
)

export default component.exports